import * as config from './config';
export default { ...config };
